import { apiClient } from './client'
import type { Author } from '../types'

export const authorsApi = {
  getAuthors: async (): Promise<Author[]> => {
    const response = await apiClient.get('/authors')
    return response.data
  },

  getAuthor: async (id: number): Promise<Author> => {
    const response = await apiClient.get(`/authors/${id}`)
    return response.data
  },

  createAuthor: async (name: string): Promise<Author> => {
    const response = await apiClient.post('/authors', { name })
    return response.data
  },

  updateAuthor: async (id: number, name: string): Promise<Author> => {
    const response = await apiClient.put(`/authors/${id}`, { name })
    return response.data
  },

  deleteAuthor: async (id: number): Promise<void> => {
    await apiClient.delete(`/authors/${id}`)
  },

  searchAuthors: async (query: string): Promise<Author[]> => {
    const response = await apiClient.get('/authors/search', {
      params: { q: query },
    })
    return response.data
  },
}
